import React from 'react'
import { Card, TextField, CardContent, Button, FormControl, Grid, InputAdornment, IconButton } from '@mui/material';

import { LinearLoading } from 'common'
import { Eye, EyeOff } from 'react-feather';

export const FormUser = ({ useFetchInit }) => {

    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        Forms,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    
    
    // ------------------------------------------------ globalStates
    const { showPassword, setShowPassword } = globalStates
    
    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    const { FormUser } = Forms
    const { formState, onInputChange } = FormUser
    
    // ------------------------------------------------ FetchData
    const { fetchSpecificUser } = FetchData
    const { loadingFetchSpecificUser } = fetchSpecificUser

    // ------------------------------------------------ Actions
    const { onSubmitForm, handleClickHideForm, handleChangeUserName } = Actions

    return (
        <div className='content'>
            <Card style={{zIndex:'1'}}>
                <CardContent>
                    <div className='h4 mt-1 mb-1'>
                        {formState.idusuario > 0
                            ? 'Actualizar Registro'
                            : 'Crear Registro'}
                    </div>
                    <div className="border-bottom border-dark"></div>
                    {loadingFetchSpecificUser && ( <LinearLoading /> )}

                    <div className="pt-3"></div>
                    <p className='text-danger'>* campos obligatorios</p>
                    <div className="pt-2"></div>

                    <form onSubmit={onSubmitForm}>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="nombreusuario"
                                        name="nombreusuario"
                                        value={formState.nombreusuario}
                                        onChange={handleChangeUserName}
                                        label='Nombre de usuario'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        // hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                                {(formState.userNameMessage !== '')&&(
                                    <span className='text-danger'>* {formState.userNameMessage}</span>
                                )}
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="nombre"
                                        name="nombre"
                                        value={formState.nombre}
                                        onChange={onInputChange}
                                        label='Nombre '
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        // hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <div className="pt-4"></div>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="apellido"
                                        name="apellido"
                                        value={formState.apellido}
                                        onChange={onInputChange}
                                        label='Apellido'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        // hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="email"
                                        name="email"
                                        value={formState.email}
                                        onChange={onInputChange}
                                        label='Correo electronico'
                                        size='small'
                                        type="email"
                                        variant="standard"
                                        // hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>

                        <div className="pt-4"></div>
                         <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="userpassword"
                                        name="userpassword"
                                        value={formState.userpassword}
                                        onChange={onInputChange}
                                        label='Contraseña'
                                        size='small'
                                        type={showPassword ? 'text' : 'password'}
                                        variant="standard"
                                        InputProps={{
                                            readOnly: false,
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={() => setShowPassword(!showPassword)}
                                                        edge="end"
                                                    >
                                                        {showPassword
                                                            ? <EyeOff />
                                                            : <Eye />
                                                        }
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                        required={false}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <div className="pt-4"></div>
                        <Grid container>
                            <Grid item>
                                <div className='update ml-auto mr-auto'>
                                    <Button
                                        style={{background: "#4b4b4c"}}
                                        variant="contained"
                                        type='submit'
                                    >
                                        <i className="fa-regular fa-floppy-disk"></i> &nbsp; Guardar
                                    </Button>
                                    &nbsp; &nbsp;
                                    <Button
                                        style={{ marginRight: 2, marginLeft: 2, background: "#ef8157" }}
                                        type='button'
                                        variant="contained"
                                        onClick={handleClickHideForm}
                                    >
                                        <i className="fa-regular fa-circle-left"></i> &nbsp; Cancelar
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                    </form>
                </CardContent>
            </Card>
        </div>
    )
}
